import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=14224b1e"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports